import React from 'react';
import Nav from '../Nav'
import Banner from '../Banner';
import './HomeScreen.css'
import Row from '../Row';
import requests from '../Requests';

function HomeScreen() {

  const currentYear = new Date().getFullYear();

  return (
    <div className='homeScreen'>
     <Nav/>
    <Banner/>
    <Row
    title="NETFLIX ORIGINALS"
    fetchUrl={requests.fetchNetflixOriginals}
isLargeRow

     />
    <Row title="Trending Now" fetchUrl={requests.fetchTrending}/>
    <Row title="Top Rated" fetchUrl={requests.fetchTopRated}/>
    <Row title="Action Movies" fetchUrl={requests.fetchActionMovies}/>
    <Row title="Comedy Movies" fetchUrl={requests.fetchComedyMovies}/>
    <Row title="Horror Movies" fetchUrl={requests.fetchHorrorMovies}/>
    <Row title="Romance Movies" fetchUrl={requests.fetchRomanceMovies}/>
    <Row title="Documentaries" fetchUrl={requests.fetchDocumentaries}/>
    <h4 style={{ textAlign: 'center', backgroundColor: 'white', padding:'10px' }}>Made with ❤️ by Dami</h4>
    <h4 style={{ textAlign: 'center',  backgroundColor: 'white', }}>&copy; {currentYear}</h4>

{/* Row */}
    </div>
  )
}

export default HomeScreen